export function makeViewLink(basePath, baseViewId, customViewId=undefined, isDefaultView=true) {
  const cleanBasePath = basePath === '/' ? '' : basePath || ''
  return isDefaultView
    ? `${cleanBasePath || ''}/view/${customViewId || baseViewId}?ignoreOverrideView`
    : `${cleanBasePath || ''}/view/${baseViewId}/custom/${customViewId}`
}
